"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../data/constants");
var HoverInViewport = /** @class */ (function () {
    function HoverInViewport() {
        var _this = this;
        var _a;
        this.options = {
            threshold: 0.8,
        };
        this.elements = document.querySelectorAll("[".concat(constants_1.DATA_HOVER_IN_VIEWPORT, "]"));
        if (!this.elements) {
            return;
        }
        if (window.innerWidth < 768) {
            var observer_1 = new IntersectionObserver(function (entries) { return _this.callback(entries); }, this.options);
            (_a = this.elements) === null || _a === void 0 ? void 0 : _a.forEach(function (element) {
                observer_1.observe(element);
            });
        }
    }
    HoverInViewport.prototype.callback = function (entries) {
        var _this = this;
        entries === null || entries === void 0 ? void 0 : entries.forEach(function (entry) {
            if (entry === null || entry === void 0 ? void 0 : entry.isIntersecting) {
                _this.elements.forEach(function (teaser) {
                    if ((entry === null || entry === void 0 ? void 0 : entry.target) === teaser) {
                        teaser === null || teaser === void 0 ? void 0 : teaser.classList.add('hover');
                    }
                    else {
                        teaser === null || teaser === void 0 ? void 0 : teaser.classList.remove('hover');
                    }
                });
            }
            else {
                _this.elements.forEach(function (teaser) {
                    if ((entry === null || entry === void 0 ? void 0 : entry.target) === teaser) {
                        teaser === null || teaser === void 0 ? void 0 : teaser.classList.remove('hover');
                    }
                });
            }
        });
    };
    return HoverInViewport;
}());
exports.default = HoverInViewport;
